import updateCart from './updateCart';
import CartDrawerDiscount from '../../components/cart-discount/cart-drawer-discount';

export default (item) => {
  return new Promise((resolve, reject) => {
    if ($('html').hasClass('cart-is-updating')) {
      return;
    }

    $('[data-slider-cart-error]').removeClass('active');
    $('html').addClass('cart-is-updating');

    const CartDrawerDiscountObj = new CartDrawerDiscount();

    $.post({
      url: '/cart/update.js',
      dataType: 'json',
      type: 'post',
      data: { updates: item },
      success: async (cart) => {
        const edit_mode = $('body').hasClass('edit-cart');
        // We still need to add the new product to the cart so we can't redirect/refresh yet
        if (edit_mode) {
          resolve(true);
          return;
        }

        if ($('.template-cart').length) {
          // updateCart(null, null, true);
          window.location.reload(false);
        } else {
          await updateCart(cart);
          CartDrawerDiscountObj.init();
        }

        resolve(true);
        return;
      },
      error: async (XHR) => {
        console.log('XHR object:', XHR);
      
        const errorDescription = XHR.responseJSON?.description || XHR.responseText || 'An unknown error occurred. Please try again later.';
        
        // Need to reset the quantity
        await updateCart(null, errorDescription);
        CartDrawerDiscountObj.init();
      },
    });
  });
};
